import { render, staticRenderFns } from "./PolicyTable.vue?vue&type=template&id=6a0c265d&lang=pug&"
import script from "./PolicyTable.vue?vue&type=script&lang=js&"
export * from "./PolicyTable.vue?vue&type=script&lang=js&"
import style0 from "./PolicyTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports